"use client";
import { env } from "@repo/env";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React, { useState } from "react";

import getQueryClient from "@/components/providers/tanstack-query";

import { createTrpcLinks } from "./links";
import { api } from "./react";

function getBaseUrl() {
  if (typeof window !== "undefined") {
    return "";
  }
  if (env.VERCEL_URL) {
    return `https://${env.VERCEL_URL}`;
  }
  return `http://localhost:${env.PORT ?? 3000}`;
}

export default function TRPCProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const queryClient = getQueryClient();
  const [trpcClient] = useState(() =>
    api.createClient({ links: createTrpcLinks(getBaseUrl()) }),
  );

  return (
    <api.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        {children}
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </api.Provider>
  );
}
